
class ShippingProgressBar extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    
    // Default properties
    this._threshold = 7500; // $75.00 in cents
    this._current = 0;
    this._currency = '$';
    this._thresholdMessage = 'Add __AMOUNT__ more to get FREE shipping!';
    this._successMessage = 'Congrats! You’ve unlocked FREE SHIPPING!';
    this._progressColor = '#4CAF50';
    this._backgroundColor = '#f0f0f0';
  }

  static get observedAttributes() {
    return [
      'threshold', 
      'current', 
      'currency', 
      'threshold-message', 
      'success-message',
      'progress-color',
      'background-color'
    ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;
    
    switch(name) {
      case 'threshold':
        this._threshold = parseInt(newValue, 10);
        break;
      case 'current':
        this._current = parseInt(newValue, 10);
        break;
      case 'currency':
        this._currency = newValue;
        break;
      case 'threshold-message':
        this._thresholdMessage = newValue;
        break;
      case 'success-message':
        this._successMessage = newValue;
        break;
      case 'progress-color':
        this._progressColor = newValue;
        break;
      case 'background-color':
        this._backgroundColor = newValue;
        break;
    }
    
    this.render();
  }

  connectedCallback() {
    // Get attributes on initial render
    if (this.hasAttribute('threshold')) {
      this._threshold = parseInt(this.getAttribute('threshold'), 10);
    }
    
    if (this.hasAttribute('current')) {
      this._current = parseInt(this.getAttribute('current'), 10);
    }
    
    if (this.hasAttribute('currency')) {
      this._currency = this.getAttribute('currency');
    }
    
    if (this.hasAttribute('threshold-message')) {
      this._thresholdMessage = this.getAttribute('threshold-message');
    }
    
    if (this.hasAttribute('success-message')) {
      this._successMessage = this.getAttribute('success-message');
    }
    
    if (this.hasAttribute('progress-color')) {
      this._progressColor = this.getAttribute('progress-color');
    }
    
    if (this.hasAttribute('background-color')) {
      this._backgroundColor = this.getAttribute('background-color');
    }
    
    this.render();
  }

  formatCurrency(cents) {
    return this._currency + (cents / 100).toFixed(0);
  }
  _formatBBCode(text) {
    return text.replace(/\[b\](.*?)\[\/b\]/g, '<strong>$1</strong>');
  }
  render() {
    // Calculate progress bar values
    const progressPercentage = Math.min(100, (this._current / this._threshold) * 100);
    const remainingAmount = Math.max(0, this._threshold - this._current);
    const formattedAmount = this.formatCurrency(remainingAmount);
    const formattedStartAmount = this.formatCurrency(0);
    const formattedEndAmount = this.formatCurrency(this._threshold);
    // Create HTML content
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
          width: 100%;
        }
        
        .progress-container {
          margin: 0;
          padding: 0;
          border-radius: 0px;
          background-color: #F1F0F8;
          margin-bottom:0;
          padding: 15px 15px;
          background: #F1F0F8;
        }
        
        .progress-message {
          margin-bottom: 5px;
          text-align: center;
          font-size: 14px;
          line-height: 120%;
          color:#595293;
        }
        
        
        .progress-bar {
          height: 5px;
          background-color: ${this._backgroundColor};
          border-radius: 21px;
          overflow: hidden;
          position: relative;
        }
        
        .progress-fill {
          height: 100%;
          width: ${progressPercentage}%;
          background-color: ${this._progressColor};
          border-radius: 5px;
          transition: width 0.4s ease-in-out;
        }
        .progress-remaining{
          font-weight:600;
          color:#FF0000;
        }
        
      </style>
      
      <div class="progress-container">
        <div class="progress-message">
          ${remainingAmount > 0 
            ? this._formatBBCode(
                this._thresholdMessage.replace('__AMOUNT__', `<span class="progress-remaining">${formattedAmount}</span>`)
              )
            : `<span class="progress-complete">${this._formatBBCode(this._successMessage)}</span>`
          }
        </div>
        <div class="progress-bar">
          <div class="progress-fill"></div>
        </div>
        
      </div>
    `;
  }
}


// Register the custom element
customElements.define('shipping-progress-bar', ShippingProgressBar);

if (!customElements.get('nv-review-slider')) {
  customElements.define(
    'nv-review-slider',
    class NVReviewSlider extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
      }

      // init here (not constructor) so the element is connected & laid out
      connectedCallback() {
        // if Swiper script is deferred, make sure it's loaded first
        if (window.Swiper) {
          this.initSwiper();
        } else {
          window.addEventListener('load', () => this.initSwiper(), { once: true });
        }
      }

      disconnectedCallback() {
        this.destroySwiper();
      }

      initSwiper() {
        if (this.swiper) return;

        this.swiper = new Swiper(this.querySelector('.swiper'), {
          // init-time options stay at the TOP level
          //initialSlide:1,
          slidesPerView: 1,    // small peek on mobile
          centeredSlides: true,
          loop: true,             // 4 slides — fine for loop
          spaceBetween: 16,
          grabCursor: true,
          observer: true,
          observeParents: true,
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true
          },
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            // only vary things Swiper can change live
            768: {
              slidesPerView: 1.5,
              spaceBetween: 24,
            }
          }
        });
      }

      destroySwiper() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }
    }
  );
}
if (!customElements.get('nv-we-reviewed-slider')) {
  customElements.define(
    'nv-we-reviewed-slider',
    class NVWeReviewedSlider extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
      }

      // init here (not constructor) so the element is connected & laid out
      connectedCallback() {
        // if Swiper script is deferred, make sure it's loaded first
        if (window.Swiper) {
          this.initSwiper();
        } else {
          window.addEventListener('load', () => this.initSwiper(), { once: true });
        }
      }

      disconnectedCallback() {
        this.destroySwiper();
      }

      initSwiper() {
        if (this.swiper) return;

        this.swiper = new Swiper(this.querySelector('.swiper'), {
          // init-time options stay at the TOP level
          slidesPerView: 1,    // small peek on mobile
          loop: false,             // 4 slides — fine for loop
          spaceBetween: 16,
          grabCursor: true,
          observer: true,
          observeParents: true,
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true
          }
        });
      }

      destroySwiper() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }
    }
  );
}
if(!customElements.get('nv-product-bundle')){
  customElements.define('nv-product-bundle', class extends HTMLElement{
    connectedCallback(){
      this.initSwiper();
      this.initOptions();
    }
    updateURL(variantId){
      if(!window.history || !history.replaceState) return;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      history.replaceState({}, '', url);
    }
    /* ---------------- your gallery, untouched ---------------- */
    initSwiper(){
      var thumbsEl=this.querySelector('.pb-thumbs-swiper'), mainEl=this.querySelector('.pb-main-swiper');
      if(!mainEl) return;
      var mobile=window.matchMedia('(max-width:1023px)').matches;
      console.log(mobile,"mobilemobile");
      this.thumbs=new Swiper(thumbsEl,{
        direction: mobile?'horizontal':'vertical',
        slidesPerView:'auto', spaceBetween:8, freeMode:true, watchSlidesProgress:true,
        navigation:{ prevEl:this.querySelector('.pb-tprev'), nextEl:this.querySelector('.pb-tnext') },
        breakpoints:{ 0:{direction:'horizontal'}, 1024:{direction:'vertical'} }
      });
      this.main=new Swiper(mainEl,{ spaceBetween:0, thumbs:{ swiper:this.thumbs } });
    }

    /* ---------------- options + pricing ---------------- */
    initOptions(){
      var dataEl=this.querySelector('[data-pb-data]');
      if(!dataEl) return;
      this.variants=JSON.parse(dataEl.textContent);

      /* product has selling plans? (plan selector only renders when true) */
      var opts=this.querySelector('.pb-options');
      this.hasSub = !!(opts && opts.dataset.hasSubscription==='true');

      this.state={
        plan: (this.querySelector('[name="pb-plan"]:checked')||{}).value || (this.hasSub ? 'subscription' : 'onetime'),
        flavour: (this.querySelector('[name="pb-flavour"]:checked')||{}).value,
        quantity: (this.querySelector('[name="pb-qty"]:checked')||{}).value
      };

      var self=this;
      this.addEventListener('change', function(e){
        if(e.target.name==='pb-plan'){ self.state.plan=e.target.value; }
        else if(e.target.name==='pb-flavour'){ self.state.flavour=e.target.value; }
        else if(e.target.name==='pb-qty'){ self.state.quantity=e.target.value; }
        else return;
        self.render();
      });

      var atcBtn=this.querySelector('[data-pb-atc]');
      if(atcBtn) atcBtn.addEventListener('click', function(){ self.addToCart(); });

      this.render();
    }

    /* AJAX add to cart — no <form>, uses the hidden inputs */
    addToCart(evt){
      var self=this;
      var idInput=this.querySelector('[data-pb-id]');
      var spInput=this.querySelector('[data-pb-selling-plan]');
      var atc=this.querySelector('[data-pb-atc]');
      if(!idInput || !atc || atc.disabled) return;
      var mainId = Number(idInput.value);

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const bundleId = new Date().getTime(); 
            
      /*var payload={ id: Number(idInput.value), quantity: 1 };
      if(spInput && spInput.value) payload.selling_plan = Number(spInput.value);*/

      var selling_plan = "";
       if(spInput && spInput.value) selling_plan = spInput.value;
      let items = [];
      const number_of_gift = Number(this.dataset.giftCount);
      if(number_of_gift > 0){
        this.querySelectorAll(".free-gift-item").forEach((el) => {
          if(el.dataset.number <= number_of_gift ){
            
            items.push(
              {
                id:Number(el.dataset.id),
                quantity:1,
                properties:{
                    "_ismain":0,
                    "_bundleid":bundleId
                }
              }
            );
          }
        });
      }
      items.push(
        {
          id:mainId,
          quantity:1,
          selling_plan:selling_plan,
          properties:{
              "_ismain":1,
              "_bundleid":bundleId
          }
        }
      );
      if(items.length <= 0) return;

      atc.disabled=true;
      atc.classList.add('is-loading');

      const formData = {
        'items': items,
        sections: this.cart.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      };
      fetch(`/cart/add.js`,{
        method: 'POST',
        headers: {
        'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then((response) => response.json())
      .then((response) => {
          const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
          publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: mainId,
              cartData: response,
          }).then(() => {
              CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
          });
          CartPerformance.measure("add:paint-updated-sections", () => {
              this.cart.renderContents(response);
          });
           document.body.classList.add("overflow-hidden");
          
      })
      .catch(error => {
          console.error('Error:', error);
          atc.disabled=false;
          atc.classList.remove('is-loading');
          self.render();
      }).finally(() => {
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          atc.disabled=false;
          atc.classList.remove('is-loading');
          self.render();
         
      });
    }

    /* find variant for a flavour + quantity combo */
    getVariant(flavour, quantity){
      return this.variants.find(function(v){ return v.flavour===flavour && v.quantity===quantity; });
    }

    isSub(){ return this.state.plan==='subscription'; }

    /* raw cents paid under current plan — for logic only, never displayed */
    paidCents(v){
      return (this.isSub() && v.sp_price!=null) ? v.sp_price : v.price;
    }

    /* pre-formatted (Liquid | money) strings for display */
    paidTotalF(v){
      return (this.isSub() && v.sp_price_f) ? v.sp_price_f : v.price_f;
    }
    paidUnitF(v){
      return (this.isSub() && v.sp_unit_f) ? v.sp_unit_f : v.unit_f;
    }

    render(){
      var self=this, s=this.state;
      var current=this.getVariant(s.flavour, s.quantity);
      if(!current) return;

      /* --- labels --- */
      var planLabel=this.querySelector('[data-pb-plan-label]');
      if(planLabel) planLabel.textContent = this.isSub() ? 'Flexible plan' : 'One-time purchase';
      var flavLabel=this.querySelector('[data-pb-flavour-label]');
      if(flavLabel) flavLabel.textContent = s.flavour;

      /* --- active classes --- */
      this.querySelectorAll('.pb-plan, .pb-flavour, .pb-qty').forEach(function(el){
        var input=el.querySelector('input');
        el.classList.toggle('is-active', input && input.checked);
      });

      /* --- per-bag price on both plan cards (based on selected qty variant) --- */
      var subEl=this.querySelector('[data-pb-plan-price="subscription"]');
      var oneEl=this.querySelector('[data-pb-plan-price="onetime"]');
      if(subEl) subEl.textContent = current.sp_unit_f || '—';
      if(oneEl) oneEl.textContent = current.unit_f;

      /* --- quantity tiles: price/each for current flavour + plan --- */
      this.querySelectorAll('[data-pb-qty-tile]').forEach(function(tile){
        var qty=tile.dataset.pbQtyTile;
        var v=self.getVariant(s.flavour, qty);
        var eachEl=tile.querySelector('[data-pb-each]');
        var offEl=tile.querySelector('[data-pb-off]');
        var flagEl=tile.querySelector('[data-pb-flag]');
        var input=tile.querySelector('input');
        if(!v){ tile.classList.add('is-unavailable'); if(input) input.disabled=true; return; }

        /* badge from variant metafields (custom.badge_text + colors) —
           rendered as a header attached to the top of the tile */
        if(flagEl){
          if(v.badge_text){
            flagEl.textContent=v.badge_text;
            tile.style.background=v.badge_bg || '';
            flagEl.style.color=v.badge_color || '';
            flagEl.hidden=false;
            tile.classList.add('has-flag');
          } else {
            flagEl.hidden=true;
            tile.classList.remove('has-flag');
          }
        }

        if(eachEl) eachEl.textContent=self.paidUnitF(v);

        /* % off vs compare_at (or vs one-time when on subscription) — raw cents math */
        var base = v.compare_at_price>0 ? v.compare_at_price :
                   (self.isSub() && v.sp_price!=null ? v.price : 0);
        var paid = self.paidCents(v);
        if(offEl){
          if(base>paid && base>0){
            if( offEl.dataset.customenableper == 'true'){
               offEl.textContent=offEl.dataset.per;
            }else{
               offEl.textContent=Math.round((1-paid/base)*100)+'% OFF';
            }
           
            offEl.hidden=false;
          } else { offEl.hidden=true; }
        }
        tile.classList.toggle('is-unavailable', !v.available);
        if(input) input.disabled=!v.available;
      });

      /* --- ATC button + hidden inputs --- */
      var idInput=this.querySelector('[data-pb-id]');
      var spInput=this.querySelector('[data-pb-selling-plan]');
      var atc=this.querySelector('[data-pb-atc]');
      var priceEl=this.querySelector('[data-pb-atc-price]');
      var cmpEl=this.querySelector('[data-pb-atc-compare]');

      if(idInput) idInput.value=current.id;
      if(spInput) spInput.value=(this.isSub() && current.sp_id) ? current.sp_id : '';
      if(this.dataset.page == 'product'){
        this.updateURL(current.id);
      }
      

      /* compare string: compare_at if set, otherwise one-time price when on subscription */
      var paidRaw=this.paidCents(current);
      var cmpRaw = current.compare_at_price>0 ? current.compare_at_price :
                   (this.isSub() && current.sp_price!=null ? current.price : 0);
      var cmpF = current.compare_at_price>0 ? current.compare_f :
                 (this.isSub() && current.sp_price!=null ? current.price_f : null);

      if(priceEl) priceEl.textContent=this.paidTotalF(current);
      if(cmpEl){
        if(cmpF && cmpRaw>paidRaw){ cmpEl.textContent=cmpF; cmpEl.hidden=false; }
        else cmpEl.hidden=true;
      }
      if(atc){
        atc.disabled=!current.available;
        if(!current.available){ priceEl.textContent='SOLD OUT'; if(cmpEl) cmpEl.hidden=true; }
      }

      /* --- gifts hook (custom.number_of_gift) ---
         Your gift section can either:
           1. read the attribute:  <nv-product-bundle data-gift-count="3">
           2. or listen:  document.addEventListener('pb:gifts-change', e => e.detail)
         Detail: { count, variantId, plan }  — count of gifts to auto-select. */
      /* gifts apply when subscription is selected;
         if the product has NO subscription at all, the metafield applies to one-time too */
         console.log(this.hasSub,"!this.hasSub");
        var giftCount = (this.isSub() || !this.hasSub) ? (current.gifts || 0) : 0;
      if(String(giftCount)!==this.dataset.giftCount){
        this.dataset.giftCount = giftCount;
        this.querySelectorAll(".free-gift-item").forEach((el) => {
          if(el.dataset.number <= giftCount ){
            el.classList.add("active");
          }else{
            el.classList.remove("active");
          }
        });
        /*
        this.dispatchEvent(new CustomEvent('pb:gifts-change', {
          bubbles:true,
          detail:{ count: giftCount, variantId: current.id, plan: s.plan }
        }));
        */
      }
    }
  });
}
class CustomDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (event) => event.code === 'Escape' && this.close());
    this.querySelector('#CustomDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.querySelector('.custom-drawer__close').addEventListener('click', this.close.bind(this));

    this.setTriggerListeners();
  }

  setTriggerListeners() {
    document.querySelectorAll('.open-custom-drawer').forEach((trigger) => {
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(trigger);
      });
      trigger.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(trigger);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    // Delay so the browser paints the initial state before animating (same trick as cart-drawer)
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.querySelector('.custom-drawer__inner');
        const focusElement = this.querySelector('.custom-drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('custom-drawer', CustomDrawer);

class CustomRemoveItem extends HTMLElement {
  constructor() {
    super();
    this.button = null;
  }

  connectedCallback() {
    this.button = this.querySelector('button') || this;
    this.button.addEventListener('click', this.handleRemove.bind(this));
  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener('click', this.handleRemove.bind(this));
    }
  }

  async handleRemove(evt) {
    const mainItemKey = this.dataset.key;
    const bundleId = this.dataset.bundleid;
    const itemSelector = `.cart-item[data-bundleid="${bundleId}"][data-ismain="0"]`;
    
    // Collect all bundle items
    const items = Array.from(document.querySelectorAll(itemSelector)).map(el => ({
      id: el.dataset.key,
      quantity: 0
    }));
    
    // Add main item
    items.push({
      id: mainItemKey,
      quantity: 0
    });
    
    // Convert to updates object
    const updates = items.reduce((acc, { id, quantity }) => {
      acc[id] = quantity;
      return acc;
    }, {});
    
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    
    if (!cart) {
      console.error('Cart element not found');
      return;
    }
    
    this.button.disabled = true;
    
    try {
      const formData = {
        updates,
        sections: cart.getSectionsToRender().map(section => section.id),
        sections_url: window.location.pathname
      };
      
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      
      const data = await response.json();
      
      CartPerformance.measure("add:paint-updated-sections", () => {
        cart.renderContents(data);
      });
      
      cart.classList.toggle('is-empty', data.item_count === 0);
      
    } catch (error) {
      console.error('Error:', error);
    } finally {
      this.button.disabled = false;
      CartPerformance.measureFromEvent("add:user-action", evt);
    }
  }
}

customElements.define('custom-remove-item', CustomRemoveItem);

class CustomTimerCountdown extends HTMLElement {
    constructor() {
        super();
        this.interval = null;
        this.endTime = null;
        this.storageKey = 'countdown-timer-end';
    }

    connectedCallback() {
        this.initTimer();
    }

    disconnectedCallback() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    initTimer() {
        const storedEndTime = localStorage.getItem(this.storageKey);
        const now = Date.now();

        if (storedEndTime) {
            const endTime = parseInt(storedEndTime);
            const remaining = endTime - now;

            if (remaining > 0) {
                // Continue with remaining time
                this.endTime = endTime;
                this.startCountdown();
                return;
            }
        }

        // Start new timer
        this.startTimer();
    }

    startTimer() {
        const hours = parseInt(this.getAttribute('data-hours')) || 2;
        const duration = hours * 60 * 60 * 1000;
        
        this.endTime = Date.now() + duration;
        localStorage.setItem(this.storageKey, this.endTime.toString());
        
        this.startCountdown();
    }

    startCountdown() {
        this.updateDisplay();
        
        if (this.interval) {
            clearInterval(this.interval);
        }
        
        this.interval = setInterval(() => {
            this.updateDisplay();
        }, 1000);
    }

    updateDisplay() {
        const now = Date.now();
        const remaining = this.endTime - now;

        if (remaining <= 0) {
            this.startTimer();
            return;
        }

        const hours = Math.floor(remaining / (1000 * 60 * 60));
        const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

        const hoursNode = this.querySelector('.hours .timer-node');
        const minutesNode = this.querySelector('.minutes .timer-node');
        const secondsNode = this.querySelector('.seconds .timer-node');

        if (hoursNode) hoursNode.textContent = String(hours).padStart(2, '0');
        if (minutesNode) minutesNode.textContent = String(minutes).padStart(2, '0');
        if (secondsNode) secondsNode.textContent = String(seconds).padStart(2, '0');
    }
}

customElements.define('custom-timer-countdown', CustomTimerCountdown);

const showCustomTab = (id) => {
  const panes = Array.from(document.querySelectorAll('[data-tab-content]'));
  const tabs = Array.from(document.querySelectorAll('[data-custom-tab]'));
    if (!panes.length) return;

    // Fall back to the first pane if the requested one doesn't exist
    let targetPane = id != null ? String(id) : null;
    if (!targetPane || !panes.some((pane) => pane.dataset.tabContent === targetPane)) {
      targetPane = panes[0].dataset.tabContent;
    }

    panes.forEach((pane) => {
      pane.toggleAttribute('hidden', pane.dataset.tabContent !== targetPane);
    });

    tabs.forEach((tab) => {
      const isActive = tab.dataset.customTab === targetPane;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
    });

};

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll(".link-opener-new").forEach((button) => {
      button.addEventListener("click",(evt) => {
        const url = button.dataset.href;
        window.open(`${url}`, '_blank', 'noopener,noreferrer');
      });
    });
    document.querySelectorAll('button[data-target]').forEach((button)=> {
      button.addEventListener('click', function() {
          const targetId = button.getAttribute('data-target');
          const targetElement = document.getElementById(targetId) || document.querySelector(`.${targetId}`);
          
          if (targetElement) {
              targetElement.scrollIntoView({ behavior: 'smooth',block: 'start' });
          }
      });
    });

    document.querySelectorAll('[data-custom-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        const tabId = tab.dataset.customTab;
        showCustomTab(tabId);
      });
    });
    if(document.querySelector("button.custom-cart-icon")){
        document.querySelector("button.custom-cart-icon").addEventListener("click",(evt) => {
            document.querySelector("#cart-icon-bubble")?.click();
        });
    }
    document.querySelectorAll('.nv-image-text-faq-block').forEach(item=>{
      const a=item.querySelector('.faq-answer');
      if(item.hasAttribute('open')) a.style.maxHeight=a.scrollHeight+'px';
      item.querySelector('.faq-title').addEventListener('click',()=>{
        const isOpen=item.hasAttribute('open');
        if(isOpen){ item.removeAttribute('open'); a.style.maxHeight=0; }
        else{ item.setAttribute('open',''); a.style.maxHeight=a.scrollHeight+'px'; }
      });
    });
    const reviewtabFilters = document.querySelectorAll(".tab-filter");
    if(reviewtabFilters.length > 0){
        reviewtabFilters.forEach((button) => {
            button.addEventListener("click",(evt) => {
               
                button.classList.add("active");
                const activeValue = button.dataset.target;
                 document.querySelectorAll(".tab-filter").forEach((el) => {
                     if(el.dataset.target == activeValue){
                          el.classList.add("active");
                      }else{
                          el.classList.remove("active");
                      }
                 });
                document.querySelectorAll(".nv-tab-reviews-item").forEach((el) => {
                    if(el.dataset.filter == activeValue){
                        el.classList.remove("hidden");
                    }else{
                        el.classList.add("hidden");
                    }
                });
            });
        });
    }
});

